import axios from "axios";
import { baseUrl, imageServiceUrl } from './baseUrl';

// Fetch All The Media
export const fetchAllMedia = async (setMediaData, toast) => {
    try {
        toast.loading('Fetching Media...');
        // const res = await axios.get(`http://15.207.69.142:4999/image/all-media`);
        // const res = await axios.get(`${baseUrl}/image/all-media`);
        const res = await axios.get(`${imageServiceUrl}/all-media`);
        // console.log(res.data);
        if(res.data.success){
            toast.dismiss();
            toast.success('Fetched All Media!');
            setMediaData(res.data.files);
        }
        if(res.data?.error){
            toast.error(res.data?.error);
        }
    } catch (err) {
        toast.error('Something Went Wrong!');
    }
}

export const fetchMedia = async () => {
    try {
        const res = await axios.get(`${imageServiceUrl}/image/all-media`);
        return res.data.files
    } catch (err) {
        console.log(err);
        throw err;
    }
}

// Delete Single Media
export const deleteSingleMedia = async (id, toast) => {
    try {
        toast.loading('Deleting Media...');
        const res = await axios.delete(`${baseUrl}/image/delete/${id}`);
        // console.log(res.data);
        if(res.data.success){
            toast.dismiss();
            toast.success('Deleted Media!');
        }
        if(res.data?.error){
            toast.error(res.data?.error);
        }
    } catch (err) {
        toast.error('Something Went Wrong!');
    }
}